import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "IPSC 2k8",
  "description": "",
  "published": "2008-05-26T00:00:00.000Z",
  "redirect_from": ["/blog/ipsc-2k8/swizec/108"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yet another Internet Problem Contest has come and passed, this was probably the most fun one I've ever partaken in ... I'd say how many that is, but I'm not really all that certain, or at all certain for that matter.`}</p>
    <p>{`This year I managed to organise a team that was actually any good, unlike last time I tried organising a team on my own when we turned out to be a bunch of newbs. All four of us, there should be more, but that's all i could muster, gathered in the conference room at Studio Poper and whacked away at the problems.`}</p>
    <p>{`After many of our best whacks we solved six, nine if you count the difficult data set as a separate problem, twelve (23 if the blahblabhahblah), which is really quite good and it secured us 127th place out of 340. Our spatially nearest competition proved to be better as they secured 57th place. Considering they were four teams competing together, about twelve people by my estimation, it was only natural that they'd be better.`}</p>
    <p>{`Hopefully next year I'll be able to assemble a larger team and we'll also all be a year better at solving problems, but even so, I'm sure it will be as fun as this year's competition was.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      